import React from 'react';
import columns from './columns';
import EcoTaxControls from './ecotax-controls';
import messages from './messages';
import Breadcrumb from 'components/Common/Breadcrumb';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';
import Table from 'features/table';

const EcoTaxPage = () => {
  const {t} = useTranslation();

  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.title())}</title>
      </Helmet>

      <Container fluid>
        <Breadcrumb
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {
              title: t('productEcoTaxPage.title'),
              path: '/dashboard/product-ecotaxes',
            },
            {title: t(...messages.title()), path: '#'},
          ]}
        />
        <Table
          url="ecotaxes"
          otherParams={{
            delimiter: '|',
          }}
          columns={columns}
          filtersComponent={EcoTaxControls}
          name="ecotaxes"
        />
      </Container>
    </div>
  );
};

export default EcoTaxPage;
